import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  DateTimePicker as MuiDateTimePicker,
  MuiPickersUtilsProvider,
  TimePicker,
  DatePicker,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import Typography from './Typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  dateInput: {
    cursor: 'pointer',
    padding: '0px 10px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: 'calc(100% - 20px)',
    borderRadius: 5,
    backgroundColor: '#e9e9e9',
    height: 30,
  },
  iconContainer: {
    width: 35,
    minHeight: 35,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRight: '1px solid #969696',
  },
  inputContainer: {
    width: 'calc(100% - 55px)',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0px 10px',
  },
  dropDownContainer: {
    borderRadius: 4,
    width: '100%',
    height: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #969696',
    cursor: 'pointer',
  },
  elipsContainer: {
    width: 'calc(100% - 10px)',
    display: 'flex',
    justifyContent: 'center',
    padding: '5px 5px',
    border: '1px solid #bfbfbf',
    borderRadius: 25,
    cursor: 'pointer',
  },
  customContainer: {
    cursor: 'pointer',
  },
}));

const DateTimePicker = (props) => {
  const classes = useStyles();
  const {
    onChange,
    timeOnly = false,
    dateOnly,
    monthOnly = false,
    variant = 'filled',
    placeHolder = 'Select Date',
    maxDate,
    minDate,
    onBlur,
    textSize = 'body1',
    custom = null,
    ...rest
  } = props;

  // variant: filled, bordered, elips, custom
  const handleChange = (time) => {
    onChange(time.valueOf());
  };

  const currentDate = new Date().getTime();

  if (timeOnly) {
    return (
      <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
        <TimePicker
          ampm={false}
          format="HH:mm:ss"
          inputProps={{ onBlur }}
          onChange={handleChange}
          TextFieldComponent={(props) =>
            variant === 'filled' ? (
              <div className={classes.dateInput} onClick={props.onClick}>
                <div style={{ display: 'flex' }}>
                  <FontAwesomeIcon
                    color="#2e2e2e"
                    icon="calendar-alt"
                    size="xs"
                    style={{ marginRight: 5 }}
                  />
                  {props.value ? (
                    <Typography variant={textSize} type="bold">
                      {props.value}
                    </Typography>
                  ) : (
                    <Typography variant={textSize} color="#bfbfbf">
                      {placeHolder}
                    </Typography>
                  )}
                </div>
                <FontAwesomeIcon color="#969696" icon="chevron-down" size="xs" />
              </div>
            ) : variant === 'bordered' ? (
              <div className={classes.dropDownContainer} onClick={props.onClick}>
                <div className={classes.iconContainer}>
                  <FontAwesomeIcon icon="calendar-alt" size="sm" color="#969696" />
                </div>
                <div className={classes.inputContainer}>
                  {props.value ? (
                    <Typography variant={textSize} type="bold">
                      {props.value}
                    </Typography>
                  ) : (
                    <Typography variant={textSize} color="#bfbfbf">
                      {placeHolder}
                    </Typography>
                  )}
                  <FontAwesomeIcon icon="chevron-down" size="sm" color="#969696" />
                </div>
              </div>
            ) : variant === 'elips' ? (
              <div className={classes.elipsContainer} onClick={props.onClick}>
                {props.value ? (
                  <Typography variant={textSize} type="bold">
                    {props.value}
                  </Typography>
                ) : (
                  <Typography variant={textSize} color="#bfbfbf">
                    {placeHolder}
                  </Typography>
                )}
              </div>
            ) : (
              <div onClick={props.onClick} className={classes.customContainer}>
                {custom}
              </div>
            )
          }
          {...rest}
        />
      </MuiPickersUtilsProvider>
    );
  } else if (dateOnly) {
    return (
      <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
        <DatePicker
          format="YYYY-MM-DD"
          maxDate={maxDate && maxDate === 'now' ? currentDate : maxDate}
          minDate={minDate && minDate === 'now' ? currentDate : minDate}
          inputProps={{ onBlur }}
          onChange={handleChange}
          leftArrowIcon={<FontAwesomeIcon icon="chevron-left" size="xs" />}
          rightArrowIcon={<FontAwesomeIcon icon="chevron-right" size="xs" />}
          TextFieldComponent={(props) =>
            variant === 'filled' ? (
              <div className={classes.dateInput} onClick={props.onClick}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <FontAwesomeIcon
                    color="#2e2e2e"
                    icon="calendar-alt"
                    size="xs"
                    style={{ marginRight: 8 }}
                  />
                  {props.value ? (
                    <Typography variant={textSize} type="bold">
                      {moment(props.value).format('D MMM YYYY')}
                    </Typography>
                  ) : (
                    <Typography variant={textSize} color="#bfbfbf">
                      {placeHolder}
                    </Typography>
                  )}
                </div>
                <FontAwesomeIcon color="#969696" icon="chevron-down" size="xs" />
              </div>
            ) : variant === 'bordered' ? (
              <div className={classes.dropDownContainer} onClick={props.onClick}>
                <div className={classes.iconContainer}>
                  <FontAwesomeIcon icon="calendar-alt" size="sm" color="#969696" />
                </div>
                <div className={classes.inputContainer}>
                  {props.value ? (
                    <Typography variant={textSize} type="bold">
                      {props.value}
                    </Typography>
                  ) : (
                    <Typography variant={textSize} color="#bfbfbf">
                      {placeHolder}
                    </Typography>
                  )}
                  <FontAwesomeIcon icon="chevron-down" size="sm" color="#969696" />
                </div>
              </div>
            ) : variant === 'elips' ? (
              <div className={classes.elipsContainer} onClick={props.onClick}>
                {props.value ? (
                  <Typography variant={textSize} type="bold">
                    {props.value}
                  </Typography>
                ) : (
                  <Typography variant={textSize} color="#bfbfbf">
                    {placeHolder}
                  </Typography>
                )}
              </div>
            ) : (
              <div onClick={props.onClick} className={classes.customContainer}>
                {custom}
              </div>
            )
          }
          {...rest}
        />
      </MuiPickersUtilsProvider>
    );
  } else if (monthOnly) {
    return (
      <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
        <DatePicker
          // views={['year', 'month']}
          views={['month']}
          format="YYYY-MM"
          maxDate={maxDate && maxDate === 'now' ? currentDate : maxDate}
          minDate={minDate && minDate === 'now' ? currentDate : minDate}
          inputProps={{ onBlur }}
          onChange={handleChange}
          leftArrowIcon={<FontAwesomeIcon icon="chevron-left" size="xs" />}
          rightArrowIcon={<FontAwesomeIcon icon="chevron-right" size="xs" />}
          TextFieldComponent={(props) =>
            variant === 'filled' ? (
              <div className={classes.dateInput} onClick={props.onClick}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <FontAwesomeIcon
                    color="#2e2e2e"
                    icon="calendar-alt"
                    size="xs"
                    style={{ marginRight: 8 }}
                  />
                  {props.value ? (
                    <Typography variant={textSize} type="bold">
                      {moment(props.value).format('MMMM YYYY')}
                    </Typography>
                  ) : (
                    <Typography variant={textSize} color="#bfbfbf">
                      {placeHolder}
                    </Typography>
                  )}
                </div>
                <FontAwesomeIcon color="#969696" icon="chevron-down" size="xs" />
              </div>
            ) : variant === 'bordered' ? (
              <div className={classes.dropDownContainer} onClick={props.onClick}>
                <div className={classes.iconContainer}>
                  <FontAwesomeIcon icon="calendar-alt" size="sm" color="#969696" />
                </div>
                <div className={classes.inputContainer}>
                  {props.value ? (
                    <Typography variant={textSize} type="bold">
                      {props.value}
                    </Typography>
                  ) : (
                    <Typography variant={textSize} color="#bfbfbf">
                      {placeHolder}
                    </Typography>
                  )}
                  <FontAwesomeIcon icon="chevron-down" size="sm" color="#969696" />
                </div>
              </div>
            ) : variant === 'elips' ? (
              <div className={classes.elipsContainer} onClick={props.onClick}>
                {props.value ? (
                  <Typography variant={textSize} type="bold">
                    {props.value}
                  </Typography>
                ) : (
                  <Typography variant={textSize} color="#bfbfbf">
                    {placeHolder}
                  </Typography>
                )}
              </div>
            ) : (
              <div onClick={props.onClick} className={classes.customContainer}>
                {custom}
              </div>
            )
          }
          {...rest}
        />
      </MuiPickersUtilsProvider>
    );
  } else {
    return (
      <>
        <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
          <MuiDateTimePicker
            dateRangeIcon={<FontAwesomeIcon icon="calendar-week" size="xs" />}
            timeIcon={<FontAwesomeIcon icon="clock" size="xs" />}
            keyboardIcon={<FontAwesomeIcon icon="calendar-day" size="xs" />}
            ampm={false}
            format="L HH:mm:ss"
            leftArrowIcon={<FontAwesomeIcon icon="chevron-left" size="xs" />}
            rightArrowIcon={<FontAwesomeIcon icon="chevron-right" size="xs" />}
            onChange={handleChange}
            maxDate={maxDate && maxDate === 'now' ? currentDate : maxDate}
            minDate={minDate && minDate === 'now' ? currentDate : minDate}
            inputProps={{ onBlur }}
            TextFieldComponent={(props) => {
              return variant === 'filled' ? (
                <div className={classes.dateInput} onClick={props.onClick}>
                  <div style={{ display: 'flex' }}>
                    <FontAwesomeIcon
                      color="#2e2e2e"
                      icon="calendar-alt"
                      size="xs"
                      style={{ marginRight: 5 }}
                    />
                    {props.value ? (
                      <Typography variant={textSize} type="bold">
                        {props.value}
                      </Typography>
                    ) : (
                      <Typography variant={textSize} color="#bfbfbf">
                        {placeHolder}
                      </Typography>
                    )}
                  </div>
                  <FontAwesomeIcon color="#969696" icon="chevron-down" size="xs" />
                </div>
              ) : variant === 'bordered' ? (
                <div className={classes.dropDownContainer} onClick={props.onClick}>
                  <div className={classes.iconContainer}>
                    <FontAwesomeIcon icon="calendar-alt" size="sm" color="#969696" />
                  </div>
                  <div className={classes.inputContainer}>
                    {props.value ? (
                      <Typography variant={textSize} type="bold">
                        {props.value}
                      </Typography>
                    ) : (
                      <Typography variant={textSize} color="#bfbfbf">
                        {placeHolder}
                      </Typography>
                    )}
                    <FontAwesomeIcon icon="chevron-down" size="sm" color="#969696" />
                  </div>
                </div>
              ) : variant === 'elips' ? (
                <div className={classes.elipsContainer} onClick={props.onClick}>
                  {props.value ? (
                    <Typography variant={textSize} type="bold">
                      {props.value}
                    </Typography>
                  ) : (
                    <Typography variant={textSize} color="#bfbfbf">
                      {placeHolder}
                    </Typography>
                  )}
                </div>
              ) : (
                <div className={classes.customContainer} onClick={props.onClick}>
                  {custom}
                </div>
              );
            }}
            {...rest}
          />
        </MuiPickersUtilsProvider>
      </>
    );
  }
};

DateTimePicker.propTypes = {
  // maxDate: "now" || timestamp
  // minDate: "now"
  onChange: PropTypes.func,
};

export default DateTimePicker;
